<template>
  <div class="px-4 pb-4">
    <data-table :columns="columns" :rows="rows.objects" :current-page="currentPage" :per-page="perPage" :has-pagination="false" @onSearch="searchFn">
      <template v-slot:actions="slotProps">
        <div class="button-items">
          <b-button v-if="checkForPermission(view_single_user_permission)" variant="info" size="sm" class="py-1 text-white" @click="singleStaff(slotProps.row.publicId)">
            View System User
          </b-button>
          <b-button v-if="checkForPermission(edit_user_permission) && checkForPermission(edit_user_profile_permission)" v-b-modal.edit-staff variant="success" size="sm" class="py-1 text-white" @click="selectStaff(slotProps.row)">
            Edit System User
          </b-button>
        </div>
      </template>
    </data-table>
    <b-modal
        id="edit-staff"
        centered
        hide-footer
        hide-header
        size="xl"
        title-class="font-18">
      <div class="p-2">
        <h3>Edit system User</h3>
        <staff-form :selected_staff="selected_staff" button_text="Edit System user" @staffAction="updateStaff"/>
        <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('edit-staff')">Close</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import DataTable from "@/components/data-table";
import StaffForm from "@/components/staff/staff-form";
import {routeItems} from "@/router/endpoints";
import {successToast} from "@/components/successToast";
import {mapActions} from "vuex";
import {permissions} from "@/router/permissions";

export default {
  name: "staff-table",
  components: {DataTable, StaffForm},
  data() {
    return {
      selected_staff: {},
      view_single_user_permission: permissions.view_single_user_permission,
      edit_user_permission: permissions.edit_user_permission,
      edit_user_profile_permission: permissions.edit_user_profile_permission,
      columns: [
        {
          field: 'name',
          label: 'Name'
        },
        {
          field: 'email',
          label: 'Email'
        },
        {
          field: 'phoneNumber',
          label: 'Phone Number'
        },
        {
          field: 'isActive',
          label: 'User Status'
        },
        {
          field: 'actions',
          label: 'Action'
        }
      ],
    }
  },
  props: {
    rows: {
      type: Object,
      required: true
    },
    perPage: {
      type: Number
    },
    searchTerm: {
      type: String
    },
    currentPage: {type: Number, default: 1}
  },
  methods:{
    ... mapActions({
      updateStaffFn: 'administration/updateSystemUser'
    }),
    async updateStaff(data){
      data.id = this.selected_staff.publicId
      await this.updateStaffFn(data).then(resp => {
        if(resp.publicId){
          successToast(`${resp.firstName} ${resp.lastName} updated successfully`)
        }
        this.$emit('refetch')
      })
    },
    selectStaff(row){
      const newProfile = row.profile === null ? {
        kraPin:"",
        idNumber:"",
        nhif:"",
        nssf:"",
        physicalAddress:"",
        poBox:"",
        dob: ""
      } : row.profile
      this.selected_staff = {
        ...row,
        profile: newProfile
      }
    },
    singleStaff(public_id){
      this.$router.push(routeItems.single_staff_route+'/'+public_id)
    },
    searchFn(data){
      this.$emit('onSearch', data)
    }
  }
}
</script>

<style scoped>

</style>
